// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"8bbf79d6","563":"0966fc0f","787":"3369bccf","790":"e3855177","844":"be4d6a02","929":"a3b240d6"}[chunkId] + ".chunk.js";
};